// extracted by mini-css-extract-plugin
module.exports = {"menu":"SelectLang_menu__LkKA8","dropDown":"SelectLang_dropDown__zqYPg"};